import copy from "copy-to-clipboard";
import { useState } from "react";
function Info({ showSuccess }) {
    const [copyText, setCopyText] = useState("");
    const copyToClipboard = (email) => {
        copy(email)
        showSuccess("복사되었습니다!")
    };
    return (<>
        {/* <div class="card border-0 rounded mb-1">
            <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                    <div class="flex-fill fw-semibold d-flex align-items-center"><strong><i class="bi-info-circle text-body text-opacity-25 my-n1 fs-4 me-2"></i> 문의하기</strong></div>
                </div>
                <div class="mb-2 flex-1">
                    <div class="d-flex align-items-center mb-2">
                        <div className="flex-1"><p class="text-opacity-95">시스템 사용 불편, 요청, 아이디어는<br />
                            편하게 의견을 남겨주세요. <br /> <b>담당 IT전략팀 한채은님</b></p></div>

                    </div>
                    <a href="https://forms.gle/8GrCw7iEi1F7QMtM9" class="btn btn-outline-primary btn-md w-100 ">
                        의견 보내기
                    </a>
                    <hr class="border-black" />
                    <div class="d-flex align-items-center mb-2" style={{ marginTop: 35 }}>
                        <div className="flex-1"><p class="text-opacity-95" >업로드 실패 등의 급한 시스템 오류 문의는<br />
                            메일 부탁 드립니다.<br /> <b>IT전략팀 알레셰르님</b></p></div>

                    </div>
                    <a href="https://mail.worksmobile.com/write/popup/?orderType=new&to=알레셰르(Alisher)%20%3Calisher@daewoong.co.kr%3E" class="btn btn-outline-primary btn-md w-100 ">
                        alisher@daewoong.co.kr  <i class="fa fa-angle-right"></i>
                    </a>
                </div>


            </div>
        </div> */}
        <div class="card rounded mb-1">
            <div class="card-body">
                <div class="fw-semibold d-flex align-items-center mb-3">
                <div class="flex-fill fw-semibold d-flex align-items-center"><strong><i class="bi-info-circle text-body text-opacity-25 my-n1 fs-4 me-2"></i> 문의하기</strong></div>
                </div>
                <div class="flex-1">
                    <div class="d-flex align-items-center">
                        <div className="flex-1"><p class="text-opacity-95 " ><small>추가적인 시스템 사용 관련 아이디어는<br />
                            편하게 의견 남겨주세요! <br /> <b>AI추진팀 하민지님</b></small></p></div>

                    </div>
                    <a href="https://forms.gle/8GrCw7iEi1F7QMtM9" class="btn btn-outline-primary btn-md w-100 ">
                        의견 남기기
                    </a>
                </div>


            </div>
        </div>
        {/* <div class="card rounded">
            <div class="card-body">
                <div class="fw-semibold d-flex align-items-center mb-3">
                <div class="flex-fill fw-semibold d-flex align-items-center"><strong><i class="bi-info-circle text-body text-opacity-25 my-n1 fs-4 me-2"></i> 문의하기</strong></div>
                </div>
                <div class="flex-1">
                    <div class="d-flex align-items-center">
                        <div className="flex-1"><p class="text-opacity-95 " ><small>업로드 실패 등의 급한 시스템 오류 문의는<br />
                            메일 부탁 드립니다.<br /> <b>IT전략팀 알레셰르님</b></small></p></div>

                    </div>
                    <a href="https://mail.worksmobile.com/write/popup/?orderType=new&to=알레셰르(Alisher)%20%3Calisher@daewoong.co.kr%3E" class="btn btn-outline-primary btn-md w-100 ">
                        alisher@daewoong.co.kr  <i class="fa fa-angle-right"></i>
                    </a>
                </div>


            </div>
        </div> */}
    </>);
}

export default Info;